import { ViewChild } from '@angular/core';
import { Component, OnInit, Input, HostBinding } from '@angular/core';
import { QuillEditorComponent } from 'ngx-quill';

import IAttribute = ZoneIQCalibration.IAttribute;
import  './custom-clipboard';

@Component({
    standalone: false,
    selector: 'comment-attribute',
    templateUrl: './comment.component.html',
    styleUrls: ['./comment.component.scss']

})
export class CommentComponent implements OnInit {
    @HostBinding('class')
    readonly hostClass = 'comment';

    @Input()
    model?: IAttribute;

    @Input()
    fieldName?: string;

    @ViewChild(QuillEditorComponent)
    editor: QuillEditorComponent;

    constructor() {}

    editorConfig = {
        toolbar: [
            ['bold', 'italic', 'underline'],
            [{ list: 'bullet' }, { list: 'ordered' }]
        ]
    };

    ngOnInit() {}

    get isEditorEmpty() {
        return (
            this.editor.editorElem.innerText.trim().length === 0 &&
            this.editor.editorElem.innerHTML.includes('img') === false
        );
    }
}
